import Vue from "vue";

/** 获取成人儿童描述 */
export const GetPeopleDes = (adults, children, baby) => {
  let $t = Vue.prototype.$t;
  let adultsStr = adults > 0 ? $t('Adults_1_x', 'function', [adults]) : ''
  let childrenStr = children > 0 ? ` ${$t('Children_1_x', 'function', [children])}` : ''
  let babyStr = baby > 0 ? ` ${$t('Baby_1_x', 'function', [baby])}` : ''
  return `${adultsStr}${childrenStr}${babyStr}`
}

/** 仓位列表数据格式化 */
export const getFlightClassLimitsFormatFun = (list) => {
  return list.map(v => {
    return {
      text: v.Name,
      value: v.Value
    }
  })
}
